import { Box, Center, Group, Text, Title } from '@mantine/core';
import { IconCamera } from '@tabler/icons-react';

import React, {useRef, useState } from 'react';


// import '@recogito/annotorious-openseadragon/dist/annotorious.min.css';

import { cacheProp, getProp, useEffectOnce } from 'utils/helper';
// import OpenSeaDragonViewer from './annotation/OpenSeaDragonViewer';
import { ApplicationTip, CaptureToolbar } from 'core/components/index';
import { TipTypes } from 'core/components/applicationTip/ApplicationTip';
import OpenSeaDragonViewer from './annotation/OpenSeaDragonViewer';
import { logger } from 'utils/logger';
import { MarkupEventTypes } from 'utils/constants';


// const useStyles = createStyles((theme) => ({
//   tooltip:{
//       position:'absolute',
//       fontSize:theme.fontSizes.xs,
//   },
  
// }));


const CommentLayout = ({image,onImageClick,imageControlSettings,settings,onSettingsChange,onCaptureChange,user, onMarkupChange}) => {

  // const { classes } = useStyles();

  const containerRef = useRef();
  const imageRef = useRef();

  // const [tipPosition,setTipPosition] = useState({left:0,top:0})
  // const imgEl = useRef();

  // The current Annotorious instance
  // const [ anno, setAnno ] = useState();

  // Current drawing tool name
  // const [ tool, setTool ] = useState('rect');

  // show draw tip
  const [showTip, setShowTip] = useState(false);

  useEffectOnce(() => {
    const hasAcknowledged = getProp(TipTypes.APPROVAL);
    if(!hasAcknowledged){
      setShowTip(true);
    }
  },[])
  /**
   * Handler for the onTipClose
   * Store the value in local storage so we don't have to display again.
   */
  const onTipClose = () => {
    cacheProp(TipTypes.APPROVAL,true);
    setShowTip(false);
  }

  const setMarkup = (type,image,data,user) => {
    logger.log(' setting markup',type, image,data,user);
    onMarkupChange(type, {image,payload:data.payload});
  }

  const fetchMarkups = (id,user) => {
    logger.log(id,user);
  }

    return (
        <Box spacing={'lg'} style={{height:'100%', display:'flex', flexDirection:'column', position:'relative'}} ref={containerRef}>
            
            {image?
              <OpenSeaDragonViewer image={image} 
                    imageControlSettings={imageControlSettings} 
                    settings={settings} 
                    setMarkup={setMarkup}
                    fetchMarkups={fetchMarkups}
                    user={user}
                    onSettingsChange={onSettingsChange}>

              </OpenSeaDragonViewer>
            :
              <Center sx={{height:'100%'}}>
                <div style={{textAlign:'center'}}>
                  <IconCamera size={48} stroke={1} opacity={0.5} />
                  <Title opacity={0.5} order={3}>Select an Image</Title>
                </div>
              </Center>
            }

            {image?
            <Group justify='center' px={'xs'} py={'xs'} style={{width:imageRef.current?.outerWidth, position:'relative'}}>
                <Group justify='apart'>
                    <Text size={'xs'}>{image.name}</Text>
                    <CaptureToolbar onCaptureChange={(type,data) => onCaptureChange(type,data,[image])} rating={image.star} color={image.colourTag} status={image.sak} />
                </Group>
                {/* <div className={classes.tooltip} style={{left:tipPosition.left,top:tipPosition.top}}>Add Comment <Kbd>(hold shift)</Kbd> </div> */}
                
            </Group>
            :
            null
            }
            
            {showTip?
              <ApplicationTip onClose={() => onTipClose()} />
            :null}
            
            
        </Box>
    )
}

export default CommentLayout;

